module.exports = __webpack_public_path__ + "static/media/SY.ec939387.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SY.svg
// module id = 2268
// module chunks = 7